import { sendAppMessage, MobileAppBus } from '@helpers/mobileApp';
import { IconBrandApple } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { Modal } from '@components/ui/Modal';
import { useEffect, useState } from 'react';
import { useOAuthMutation } from '@http';
import { toast } from 'react-toastify';
import { useAppStore } from '@stores';

export function AppleSignIn() {
  const [notFound, setNotFound] = useState(false);

  const { t } = useTranslation(undefined, { keyPrefix: 'AppleSignIn' });
  const { mutateAsync } = useOAuthMutation();
  const { userData, refetch } = useAppStore();

  useEffect(() => {
    MobileAppBus.addEventListener('appleSignIn', ({ token }: { token: string }) => {
      postServer(token);
    });
  }, []);

  const postServer = async (code: string) => {
    const data = await mutateAsync({ type: 'apple', code });

    if (!data) {
      return toast(t('error'), { type: 'error' });
    }

    if (data.jwt) {
      localStorage.setItem('authToken', data.jwt);
      return window.location.reload();
    }

    if (data.notFound) {
      return setNotFound(true);
    }

    refetch();
  };

  const startLogin = () => {
    sendAppMessage('appleSignIn');
  };

  if (userData.appleSub) {
    return (
      <button
        className="btn flex w-full items-center justify-center bg-black border-gray-700 rounded-lg text-lime-500"
        onClick={startLogin}
      >
        <IconBrandApple fill="currentColor" size={18} />
        <p className="ml-2">{t('connected')}</p>
      </button>
    );
  }

  return (
    <>
      <Modal onRequestClose={() => setNotFound(false)} isOpen={notFound}>
        <p className="text-center text-red-500 my-4">{t('notFound')}</p>
      </Modal>

      <button
        className="btn flex w-full items-center justify-center bg-black border-gray-700 rounded-lg"
        onClick={startLogin}
      >
        <IconBrandApple fill="white" size={18} />
        <p className="ml-2">{t('button')}</p>
      </button>
    </>
  );
}